import { useEffect, useState } from "react";

import useData from "./useData";

// Loads a list one page at a time and appends each page. Remount (eg change the key) to start over.
// selectPage(data) returns { items, total } for the paged field and its *Count field.
export default function usePagedData(query, variables, selectPage, { pageSize, skip = false }) {
  const [offset, offsetSet] = useState(0);
  const [items, itemsSet] = useState([]);
  const [data, { loading }] = useData(query, { ...variables, offset, limit: pageSize }, { skip });

  const page = data ? selectPage(data) : null;
  const pageItems = page?.items;

  useEffect(() => {
    if (!pageItems) return;
    itemsSet((prev) => {
      const loadedIds = new Set(prev.map((item) => item.id));
      const added = pageItems.filter((item) => !loadedIds.has(item.id));
      return added.length ? [...prev, ...added] : prev;
    });
  }, [pageItems]);

  const total = page?.total ?? items.length;

  return {
    page,
    items,
    remaining: Math.max(total - items.length, 0),
    loading,
    loadMore: () => offsetSet(items.length),
  };
}
